export const flatternErrors = (errors, newErrorList = []) => {
  Object.keys(errors).forEach((field) => {
    if (errors[field]?.message) {
      newErrorList.push(field);
    } else if (errors[field] && typeof errors[field] === 'object') {
      newErrorList = flatternErrors(errors[field], newErrorList);
    }
  });

  return newErrorList;
};

export default flatternErrors;
